import {BaseEditItemStore} from "@leap4/frontend";
import {ITask} from "../../../../interfaces/ITask";

export class EditTaskStore extends BaseEditItemStore<ITask>{
    entityName: string = "Task";
}
